export default "__VITE_ASSET__BiVk9gCw__"